import type {PS} from '@wix/document-services-types'
import _ from 'lodash'
import * as santaCoreUtils from '@wix/santa-core-utils'
import generalInfo from '../../siteMetadata/generalInfo'
import actionsAndBehaviors from '../../actionsAndBehaviors/actionsAndBehaviors'
import componentDetectorAPI from '../../componentDetectorAPI/componentDetectorAPI'
import dataModel from '../../dataModel/dataModel'
import constants from '../../constants/constants'
import type {DsFixer} from '../dsDataFixers'

function getMobileSettingsPointer(ps: PS) {
    const siteStructureDataPointer = ps.pointers.data.getDataItemFromMaster(santaCoreUtils.siteConstants.MASTER_PAGE_ID)
    return ps.pointers.getInnerPointer(siteStructureDataPointer, 'mobileSettings')
}

function isActionAndBehavior(behaviorObj) {
    return _.has(behaviorObj, 'action') && _.has(behaviorObj, 'behavior')
}

function isAnimationBehavior(behavior) {
    if (isActionAndBehavior(behavior)) {
        return false
    }
    return _.get(behavior, 'type', 'animation') === 'animation'
}

function setBehaviorsWithoutViewModeToDesktop(ps: PS) {
    const comps = componentDetectorAPI.getAllComponents(ps)
    _.forEach(comps, comp => {
        // filter animations behavior
        const updatedBehaviors = _.map(actionsAndBehaviors.getBehaviors(ps, comp), behavior => {
            if (isAnimationBehavior(behavior) && !_.has(behavior, 'viewMode')) {
                // @ts-expect-error
                behavior.viewMode = constants.VIEW_MODES.DESKTOP
            }
            return behavior
        })
        if (updatedBehaviors.length) {
            const behaviorsToSet = JSON.stringify(updatedBehaviors)
            dataModel.updateBehaviorsItem(ps, comp, behaviorsToSet)
        }
    })
}

function siteNeverSaved(ps: PS) {
    return generalInfo.isDraft(ps)
}

function setMobileAnimationsEnabledFlag(ps: PS, animationsEnabled: boolean) {
    const siteStructureDataPointer = getMobileSettingsPointer(ps)
    ps.dal.set(siteStructureDataPointer, {animationsEnabled})
}

function exec(ps: PS) {
    const mobileSettingsPointer = getMobileSettingsPointer(ps)
    if (siteNeverSaved(ps)) {
        // new site
        setMobileAnimationsEnabledFlag(ps, true)
    } else if (!ps.dal.isExist(mobileSettingsPointer)) {
        // old site
        setMobileAnimationsEnabledFlag(ps, false)
        // getAnimations and set viewMode = 'DESKTOP'
        setBehaviorsWithoutViewModeToDesktop(ps)
    }
}

const fixer: DsFixer = {
    exec,
    name: 'mobileAnimationsDataFixer',
    version: 1,
    fixerRequiresReruns: true
}
export default fixer
